import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './NewCircleModalCurators.scss';
import './NewCircleModalResults.scss';

import { getCuratorsByHierarchy } from '../../../../APIClient/shop';
import CuratorCardNew from '../../../Curators/CuratorCardNew';

const NewCircleModalCurators = props => {
  const { selectedCurators, selectedBrands, selectedDepartments, selectedIndustries, activeGroup } = props;

  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [page, setPage] = React.useState(0);
  const [curatorResults, setCuratorResults] = React.useState([]);
  const [canFetchMore, setCanFetchMore] = React.useState(true);
  const catalogHash = [...selectedBrands, ...selectedDepartments, ...selectedIndustries].map(i => i.id).join(',');
  React.useEffect(() => {
    setIsLoading(true);
    const LIMIT = 40;
    const params = {
      page: page,
      limit: LIMIT
    };
    if (selectedBrands.length) params.AllBrand_ids = selectedBrands.map(b => b.id).join(',');
    if (selectedDepartments) params.Department_ids = selectedDepartments.map(d => d.id).join(',');
    if (selectedIndustries) params.Industry_ids = selectedIndustries.map(i => i.id).join(',');
    getCuratorsByHierarchy(params)
      .then(({ curators }) => {
        setCuratorResults([...curatorResults.slice(0, page * LIMIT), ...curators]);
        setCanFetchMore(curators.length === LIMIT);
      })
      .catch(error => {
        setErrorMessage(error?.message || 'An error occurred while fetching curators');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [catalogHash, page]);

  const isLoadingFirstPage = isLoading && page === 0;
  const isLoadingSubsequentPage = isLoading && page > 0;
  return (
    <div className='new-circle-modal-curators-container new-circle-modal-results-container'>
      <div className='new-circle-modal-body-title-container'>
        <div className='title'>You might be interested in</div>
        <div className='subtitle'>
          {activeGroup
            ? `Check out the curators below to add to your circle "${activeGroup.title}".`
            : 'Add a few of the curators below to start building your circle, you can always edit it later.'}
        </div>
      </div>
      <div className='results curator-results'>
        {isLoadingFirstPage ? (
          _.range(12).map(i => <CuratorCardNew isLoading />)
        ) : errorMessage ? (
          <div>{errorMessage}</div>
        ) : (
          curatorResults.map(c => {
            const isAlreadyInGroup = activeGroup?.users?.some(sc => sc.id === c.id);
            const isSelected = selectedCurators.some(sc => sc.id === c.id) || isAlreadyInGroup;
            const isAnotherSelected = !isSelected && !!selectedCurators.length;
            const toggle = () =>
              isAlreadyInGroup
                ? window.ALERT.warn('This curator is already in your circle.')
                : isSelected
                ? props.setSelectedCurators(selectedCurators.filter(sc => sc.id !== c.id))
                : props.setSelectedCurators([...selectedCurators, c]);
            return (
              <CuratorCardNew
                isLoading={isLoadingFirstPage}
                isSelected={isSelected}
                isAnotherSelected={isAnotherSelected}
                isSelectable
                onToggle={toggle}
                key={c.id}
                curator={c}
              />
            );
          })
        )}
      </div>
      {canFetchMore && (
        <div onClick={() => !isLoadingSubsequentPage && setPage(page + 1)} className='pagination'>
          {isLoadingSubsequentPage ? 'Loading...' : 'View More'}
        </div>
      )}
      <div className='upsell-text'>
        Hundreds of thousands of the top content creators in the world are discoverable on ShopMy, if you don't find someone you know here, DM them on
        Instagram, TikTok to see if they have a ShopMy account - they probably do!
      </div>
    </div>
  );
};

NewCircleModalCurators.propTypes = {
  shop: PropTypes.object.isRequired,
  selectedCurators: PropTypes.array.isRequired,
  setSelectedCurators: PropTypes.func.isRequired,
  activeGroup: PropTypes.object
};

export default NewCircleModalCurators;
